import React from 'react';

import styles from './form.module.scss';
export const Form = ({ className, ...props }: React.ComponentPropsWithoutRef<'form'>) => (
  <form className={className ? `${styles['form']} ${className}` : styles['form']} {...props} />
);
